module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-mini-calc-icons"
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute",
      "display": "none"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "age-calculator",
      "aria-labelledby": "age-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Age Calculator")]), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "45.7",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 42.9C10.4 42.9.8 33.3.8 21.5S10.4.2 22.2.2s21.4 9.6 21.4 21.4-9.7 21.3-21.4 21.3zm0-40.7c-10.6 0-19.3 8.7-19.3 19.3s8.7 19.3 19.3 19.3c10.6 0 19.3-8.7 19.3-19.3S32.8 2.2 22.2 2.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 22.5c-.6 0-1-.5-1-1V9.7c0-.6.5-1 1-1 .6 0 1 .5 1 1v11.8c0 .6-.5 1-1 1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M34 22.5H22.2c-.6 0-1-.5-1-1 0-.6.5-1 1-1H34c.6 0 1 .5 1 1 0 .6-.5 1-1 1z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "75",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.7 54.1c-.5 0-1-.4-1.1-.9-.1-.6.3-1.1.9-1.2l17-2.3c.6-.1 1.1.3 1.2.9.1.6-.3 1.1-.9 1.2l-17 2.3h-.1zM83.8 54.1h-.1l-17-2.3c-.6-.1-1-.6-.9-1.2.1-.6.6-1 1.2-.9L84 52c.6.1 1 .6.9 1.2-.1.5-.5.9-1.1.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60.3 120c-18 0-35.2-13.6-44.1-34.8-5.7-2-10.6-7.2-12.8-13.7-3.5-10.2.6-22.2 8.7-25.9l1.8-5.3 4 1.4-2.5 7.1-1 .3c-6.5 2.3-9.9 12.5-7 20.8 1.9 5.6 6.1 10 11 11.3l1 .3.4 1c8.1 20.1 24 33 40.5 33 16.4 0 32.3-12.9 40.4-32.8l.4-1 1.1-.2c5-1.1 9.6-5.7 11.6-11.5 2.8-8.1.2-14.9-6.7-17.3-1.3-.4-1.5-1.5-1.7-2.8h-.1l-.2-1.4C101.5 22.9 82.6 4.3 60.3 4.3 53 4.3 46 6.4 39.5 10.5l-2.3-3.6C44.3 2.4 52.3 0 60.3 0c24.4 0 45 20.1 49 47.8.2.4.2 1 .3 1.5 8.4 3.5 11.7 12.3 8.2 22.3-2.4 6.9-7.5 12.2-13.6 14-8.8 20.9-26 34.4-43.9 34.4zm48.2-71.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "care-calculator",
      "aria-labelledby": "care-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Care Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 88.3c-.5 0-1-.2-1.4-.5-1.4-1.1-34.2-26.1-43-44-.6-1.2-6.3-12.9 0-26.7C24.4-1.6 38.5-.7 44.1.6 50.8 2.1 56.8 6.3 60 11.1c3.2-4.8 9.2-9 15.9-10.6C81.5-.8 95.5-1.7 104.4 17c6.3 13.8.6 25.4-.1 26.7-8.8 17.9-41.6 42.9-43 44-.3.4-.8.6-1.3.6zM38.7 4.6c-5.8 0-13.4 2.7-19 14.5-5.3 11.8-.6 21.6 0 22.6C27.1 56.7 53.6 78 60 83.1c6.4-5 32.9-26.4 40.3-41.3.6-1.1 5.3-10.9 0-22.7C93.1 4 82.6 3.8 76.9 5.1c-8.2 1.9-14.6 8.5-14.6 13 0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3c0-4.5-6.4-11.1-14.6-13-1.3-.3-2.8-.5-4.4-.5zM59.5 120c-18.7 0-38.6-4.1-38.6-11.6s19.9-11.6 38.6-11.6c18.7 0 38.6 4.1 38.6 11.6S78.2 120 59.5 120zm0-21c-21.5 0-36.4 5-36.4 9.4s14.9 9.4 36.4 9.4 36.4-5 36.4-9.4S81 99 59.5 99z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M59.5 113c-7.9 0-22.8-1.2-22.8-5.9s14.9-5.9 22.8-5.9 22.8 1.2 22.8 5.9-14.9 5.9-22.8 5.9zm0-9.6c-13.4 0-20.5 2.6-20.6 3.7.1 1.1 7.2 3.7 20.6 3.7s20.5-2.6 20.6-3.7c0-1.1-7.2-3.7-20.6-3.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "dependency-multiplicand",
      "aria-labelledby": "dependency-multiplicand",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Dependency Multiplicand")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.6 30.5H2c-1.1 0-2-.9-2-2s.9-2 2-2h41.6c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.8 51.3c-1.1 0-2-.9-2-2V7.7c0-1.1.9-2 2-2s2 .9 2 2v41.6c0 1.1-.9 2-2 2zM111.9 114.3c-.5 0-1-.2-1.4-.6L81.1 84.3c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l29.4 29.4c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M82.5 114.3c-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l29.4-29.4c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-29.4 29.4c-.4.4-.9.6-1.4.6zM8.1 114.3c-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l29.4-29.4c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L9.5 113.7c-.4.4-.9.6-1.4.6zM118 30.5H76.4c-1.1 0-2-.9-2-2s.9-2 2-2H118c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "earnings",
      "aria-labelledby": "earnings",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Earnings Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.4 81.7c-1.2 0-2.1-1-2.1-2.1V29.7c0-10.1 2.3-17.9 6.8-23C52 2.3 57.4 0 63.9 0c13.2 0 27.7 10 27.7 19 0 1.2-1 2.1-2.1 2.1s-2.1-1-2.1-2.1c0-6.1-12.1-14.8-23.4-14.8-3.6 0-8.8.9-12.6 5.3-3.8 4.3-5.7 11.1-5.7 20.2v49.8c-.2 1.2-1.1 2.2-2.3 2.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M89.5 82.6c-.1 0-.1 0 0 0l-58.9-.9c-1.2 0-2.1-1-2.1-2.2 0-1.2 1-2.1 2.1-2.1l58.9.9c1.2 0 2.1 1 2.1 2.2 0 1.1-1 2.1-2.1 2.1zM65.9 46.2l-35.4-.9c-1.2 0-2.1-1-2.1-2.2 0-1.2.9-2.2 2.2-2.1l35.3.9c1.2 0 2.1 1 2.1 2.2 0 1.1-.9 2.1-2.1 2.1z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120c-19.4 0-40.1-4.2-40.1-12S40.5 96 60 96s40.1 4.2 40.1 12-20.7 12-40.1 12zm0-21.8c-22.3 0-37.9 5.2-37.9 9.8 0 4.7 15.6 9.8 37.9 9.8s37.9-5.2 37.9-9.8c0-4.6-15.6-9.8-37.9-9.8z"
    }
  })]), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 112.8c-8.2 0-23.6-1.3-23.6-6.1s15.5-6.1 23.6-6.1c8.2 0 23.6 1.3 23.6 6.1s-15.4 6.1-23.6 6.1zm0-10c-14.2 0-21.5 2.8-21.5 3.9 0 1.2 7.3 3.9 21.5 3.9s21.5-2.7 21.5-3.9c0-1.2-7.3-3.9-21.5-3.9z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "inflation-calculator",
      "aria-labelledby": "inflation-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Inflation Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M33.9 120H18.2c-3.5 0-6.4-2.9-6.4-6.4V48.8c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v64.8c0 3.5-2.9 6.4-6.4 6.4zM18.2 46.7c-1.2 0-2.1 1-2.1 2.1v64.8c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V48.8c0-1.2-1-2.1-2.1-2.1H18.2zM67.9 120H52.1c-3.5 0-6.4-2.9-6.4-6.4V30.4c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v83.2c0 3.5-2.8 6.4-6.3 6.4zM52.1 28.3c-1.2 0-2.1 1-2.1 2.1v83.2c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V30.4c0-1.2-1-2.1-2.1-2.1H52.1zM101.8 120H86.1c-3.5 0-6.4-2.9-6.4-6.4V6.4c0-3.5 2.9-6.4 6.4-6.4h15.7c3.5 0 6.4 2.9 6.4 6.4v107.3c-.1 3.4-2.9 6.3-6.4 6.3zM86.1 4.2c-1.2 0-2.1 1-2.1 2.1v107.3c0 1.2 1 2.1 2.1 2.1h15.7c1.2 0 2.1-1 2.1-2.1V6.4c0-1.2-1-2.1-2.1-2.1H86.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "interest",
      "aria-labelledby": "interest",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Interest Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M12.2 120c-.5 0-1-.2-1.4-.5-.9-.8-1-2.1-.3-3L104.3 4.6c.8-.9 2.1-1 3-.3.9.8 1 2.1.3 3L13.8 119.2c-.4.5-1 .8-1.6.8zM30.8 41.6C19.3 41.6 10 32.3 10 20.8 10.1 9.3 19.4 0 30.8 0s20.8 9.3 20.8 20.8c0 11.4-9.3 20.8-20.8 20.8zm0-37.3c-9.1 0-16.5 7.4-16.5 16.5s7.4 16.5 16.5 16.5 16.5-7.4 16.5-16.5S39.9 4.3 30.8 4.3zM89.2 120c-11.5 0-20.8-9.3-20.8-20.8s9.3-20.8 20.8-20.8S110 87.7 110 99.2 100.6 120 89.2 120zm0-37.3c-9.1 0-16.5 7.4-16.5 16.5s7.4 16.5 16.5 16.5 16.5-7.4 16.5-16.5-7.4-16.5-16.5-16.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "interpolated",
      "aria-labelledby": "interpolated",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Interpolated Multipliers")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M100.8 77.8V42.4c10.7-1.1 19-10.1 19-21.1C119.8 9.6 110.3.1 98.6.1c-11 0-20 8.4-21.1 19H42.4C41.4 8.5 32.4 0 21.4 0 9.7 0 .2 9.5.2 21.2c0 11 8.4 20 19 21.1v34.1C8.5 77.5.2 86.5.2 97.5c0 11.7 9.5 21.2 21.2 21.2 10.5 0 19.2-7.7 20.9-17.8h35.3c-.1-.6-.1-1.3-.1-1.9 0 11.7 9.5 21.2 21.2 21.2s21.2-9.5 21.2-21.2c-.1-11.1-8.5-20.2-19.1-21.2zM98.6 4.4c9.3 0 16.9 7.6 16.9 16.9 0 9.3-7.6 16.9-16.9 16.9-9.3 0-16.9-7.6-16.9-16.9 0-9.3 7.6-16.9 16.9-16.9zM4.4 21.2c0-9.3 7.6-16.9 16.9-16.9 9.3 0 16.9 7.6 16.9 16.9s-7.6 16.9-16.9 16.9c-9.3 0-16.9-7.6-16.9-16.9zm17 93.1c-9.3 0-16.9-7.6-16.9-16.9 0-9.3 7.6-16.9 16.9-16.9 9.3 0 16.9 7.6 16.9 16.9 0 9.3-7.6 16.9-16.9 16.9zm21.1-17.8c-.4-10.6-8.6-19.2-19-20.2V42.2c9.9-1 17.8-8.9 18.9-18.8h35.2c1 10 9 17.9 18.9 18.9v35.4c-9.9 1-17.8 8.9-18.9 18.7H42.5zm56.1 19.3c-9.3 0-16.9-7.6-16.9-16.9S89.3 82 98.6 82c9.3 0 16.9 7.6 16.9 16.9s-7.5 16.9-16.9 16.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.9 97.3l6.8-6.8c.4-.4.4-1.1 0-1.5-.4-.4-1.1-.4-1.5 0l-6.8 6.8-6.9-6.8c-.4-.4-1.1-.4-1.5 0s-.4 1.1 0 1.5l6.8 6.8-6.8 6.8c-.4.4-.4 1.1 0 1.5.2.2.5.3.7.3.3 0 .5-.1.7-.3l6.8-6.8 6.8 6.8c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1.1 0-1.5l-6.5-6.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "life-expectancy",
      "aria-labelledby": "life-expectancy",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Life Expectancy Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M27.1 119.2c-.1-.7-2.5-16.3 3-30.6 3.3-8.5 9.2-14 14-18.3 4.2-3.8 7.5-6.8 7.5-10.2s-3.3-6.4-7.5-10.2c-4.8-4.4-10.8-9.8-14-18.3C24.6 17.3 27 1.7 27.1 1l4.3.7c0 .2-2.3 15.2 2.7 28.4C37 37.4 42.3 42.3 47 46.6c4.8 4.3 8.9 8.1 8.9 13.4s-4.1 9.1-8.9 13.4c-4.7 4.3-10 9.1-12.9 16.7-5.1 13.2-2.8 28.2-2.7 28.4l-4.3.7zM92.9 119.2l-4.3-.7c0-.2 2.3-15.2-2.7-28.4C83 82.6 77.7 77.7 73 73.4c-4.8-4.3-8.9-8.1-8.9-13.4s4.1-9.1 8.9-13.4c4.7-4.3 10-9.1 12.9-16.7C91 16.7 88.7 1.6 88.7 1.5L93 .8c.1.7 2.5 16.3-3 30.6-3.3 8.5-9.2 14-14 18.3-4.2 3.8-7.5 6.8-7.5 10.2s3.3 6.4 7.5 10.2c4.8 4.4 10.8 9.8 14 18.3 5.5 14.5 3.1 30.1 2.9 30.8z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101 4.3H19c-1.2 0-2.2-1-2.2-2.2S17.8 0 19 0h82c1.2 0 2.2 1 2.2 2.2s-1 2.1-2.2 2.1z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101 120H19c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2h82c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "pension",
      "aria-labelledby": "pension",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.6 29.2c.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3H14.6c-.4 0-.6-.1-.8-.3-.2-.2-.3-.4-.3-.8 0-.3.1-.6.3-.7s.5-.3.8-.3h2v-7.4h-2.2c-.3 0-.5-.1-.6-.2-.2-.2-.2-.4-.2-.6s.1-.5.2-.6c.2-.2.4-.2.6-.2h2.2v-4.1c0-1.7.5-3.1 1.5-4.1 1-1 2.4-1.5 4.2-1.5 1.2 0 2.3.2 3.4.6 1.1.4 2 1 2.8 1.8.3.3.5.6.5 1 0 .3-.1.5-.2.7-.2.2-.3.3-.6.3-.2 0-.5-.1-.8-.3-1-.8-1.8-1.3-2.6-1.6-.8-.3-1.6-.5-2.4-.5-1 0-1.8.3-2.4.9-.6.6-.9 1.6-.9 2.8v3.9h4.6c.3 0 .5.1.6.2.2.2.2.4.2.6s-.1.5-.2.6c-.2.2-.4.2-.6.2H19v7.4h8.8c.4.1.6.2.8.4z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "45.7",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.2 42.9C10.4 42.9.8 33.3.8 21.5S10.4.2 22.2.2s21.4 9.6 21.4 21.4-9.7 21.3-21.4 21.3zm0-40.7c-10.6 0-19.3 8.7-19.3 19.3s8.7 19.3 19.3 19.3 19.3-8.7 19.3-19.3S32.8 2.2 22.2 2.2z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "75",
      "cy": "68.3",
      "r": "3.2"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M36.7 54.1c-.5 0-1-.4-1.1-.9-.1-.6.3-1.1.9-1.2l17-2.3c.6-.1 1.1.3 1.2.9.1.6-.3 1.1-.9 1.2l-17 2.3h-.1zM83.8 54.1l-17.1-2.3c-.6-.1-1-.6-.9-1.2.1-.6.6-1 1.2-.9L84 52c.6.1 1 .6.9 1.2-.1.5-.5.9-1.1.9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60.3 120c-18 0-35.2-13.6-44.1-34.8-5.7-2-10.6-7.2-12.8-13.7-3.5-10.2.6-22.2 8.7-25.9l1.8-5.3 4 1.4-2.5 7.1-1 .3c-6.5 2.3-9.9 12.5-7 20.8 1.9 5.6 6.1 10 11 11.3l1 .3.4 1c8.1 20.1 24 33 40.5 33 16.4 0 32.3-12.9 40.4-32.8l.4-1 1.1-.2c5-1.1 9.6-5.7 11.6-11.5 2.8-8.1.2-14.9-6.7-17.3-1.3-.4-1.5-1.5-1.7-2.8h-.1l-.2-1.4C101.5 22.9 82.6 4.3 60.3 4.3 53 4.3 46 6.4 39.5 10.5l-2.3-3.6C44.3 2.4 52.3 0 60.3 0c24.4 0 45 20.1 49 47.8.2.4.2 1 .3 1.5 8.4 3.5 11.7 12.3 8.2 22.3-2.4 6.9-7.5 12.2-13.6 14-8.8 20.9-26 34.4-43.9 34.4zm48.2-71.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "period-dates",
      "aria-labelledby": "period-dates",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Period Between Two Dates")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M100.1 14h-6.4V4.3c0-2.4-1.9-4.3-4.3-4.3H74.1c-2.4 0-4.3 1.9-4.3 4.3V14H50.2V4.3c0-2.4-1.9-4.3-4.3-4.3H30.6c-2.4 0-4.3 1.9-4.3 4.3V14h-6.4C12.8 14 7 19.8 7 26.9V107c0 7.1 5.8 12.9 12.9 12.9H100c7.1 0 12.9-5.8 12.9-12.9V26.9c.1-7.1-5.7-12.9-12.8-12.9zm-26-9.7h15.2v25.6H74.1V4.3zm-43.5 0h15.2v25.6H30.6V4.3zm78.1 102.8c0 4.7-3.9 8.6-8.6 8.6H19.9c-4.7 0-8.6-3.9-8.6-8.6V26.9c0-4.7 3.9-8.6 8.6-8.6h6.4v11.6c0 2.4 1.9 4.3 4.3 4.3h15.2c2.4 0 4.3-1.9 4.3-4.3V18.3h19.6v11.6c0 2.4 1.9 4.3 4.3 4.3h15.2c2.4 0 4.3-1.9 4.3-4.3V18.3h6.4c4.7 0 8.6 3.9 8.6 8.6v80.2z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M41.9 71.9H20.8V50.7H42v21.2zm-19-2.2h16.9V52.9H22.9v16.8zM70.6 71.9H49.4V50.7h21.2v21.2zm-19-2.2h16.9V52.9H51.6v16.8zM99.2 71.9H78.1V50.7h21.2v21.2zm-19-2.2h16.9V52.9H80.2v16.8zM41.9 101.8H20.8V80.6H42v21.2zm-19-2.2h16.9V82.8H22.9v16.8zM70.6 101.8H49.4V80.6h21.2v21.2zm-19-2.2h16.9V82.8H51.6v16.8zM99.2 101.8H78.1V80.6h21.2v21.2zm-19-2.2h16.9V82.8H80.2v16.8z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "table-e-f-discounts",
      "aria-labelledby": "table-e-f-discounts",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Pre and Post Assessment Discounts")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M43.4 111.4L0 70.2 55.2 12l27.3-3.4 18.2 17.2-2 27.4-.4.5-54.9 57.7zM5.1 70l38.2 36.2 51.8-54.6 1.8-24.4-15.6-14.8L57 15.5 5.1 70zm71.3-24.3c-3.2 0-6.2-1.2-8.6-3.4-2.4-2.3-3.8-5.4-3.9-8.7-.1-3.3 1.1-6.5 3.4-8.9s5.4-3.8 8.7-3.9c3.4-.1 6.5 1.1 8.9 3.4 2.4 2.3 3.8 5.4 3.9 8.7.1 3.3-1.1 6.5-3.4 8.9-2.3 2.4-5.4 3.8-8.7 3.9h-.3zm0-21.3h-.2c-2.4.1-4.5 1-6.2 2.7-1.6 1.7-2.5 3.9-2.4 6.3.1 2.4 1 4.5 2.7 6.2 1.7 1.6 4 2.5 6.3 2.4 2.4-.1 4.5-1 6.2-2.7 1.6-1.7 2.5-3.9 2.4-6.3-.1-2.4-1-4.5-2.7-6.2-1.7-1.5-3.9-2.4-6.1-2.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M86.8 35.9c-6.3-.2-7.6-2.2-7.6-3.8.1-6.1 19.3-16.1 35.2-16.3 4.4-.1 5.5 1.4 5.6 2.6.6 4.5-10.7 12.6-21.6 15.4l-.2-.8c10.9-2.9 21.4-10.8 20.9-14.4-.2-1.6-2.7-1.8-4.7-1.8-15.7.2-34.2 10.3-34.3 15.4 0 1.7 2.4 2.7 6.7 2.8v.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "arrow",
      "aria-labelledby": "arrow",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M94.3 63.1H25.7c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4h68.7c1.9 0 3.4 1.5 3.4 3.4s-1.6 3.4-3.5 3.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M94.3 63.1c-.6 0-1.2-.2-1.8-.5L71.4 49c-1.6-1-2-3.1-1-4.6 1-1.6 3.1-2 4.6-1l21.1 13.5c1.6 1 2 3.1 1 4.6-.6 1-1.7 1.6-2.8 1.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M73.2 77.1c-1.1 0-2.1-.5-2.8-1.5-1-1.5-.6-3.6.9-4.6l21.1-14.1c1.5-1 3.6-.6 4.6.9 1 1.5.6 3.6-.9 4.6l-21 14.2c-.6.4-1.3.5-1.9.5z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120C26.9 120 0 93.1 0 60S26.9 0 60 0s60 26.9 60 60-26.9 60-60 60zM60 6.7C30.6 6.7 6.7 30.6 6.7 60s23.9 53.3 53.3 53.3 53.3-23.9 53.3-53.3S89.4 6.7 60 6.7z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "logo",
      "aria-labelledby": "logo",
      "role": "img",
      "viewBox": "0 0 230.4 120",
      "width": "230.4",
      "height": "120"
    }
  }, [_c('title', [_vm._v("ABC Quantum logo")]), _c('path', {
    staticClass: "logo-text",
    attrs: {
      "d": "M28.1 82.8c.8.8 1.1 1.7 1.1 2.8v30.6c0 1.1-.3 2.2-1.1 2.8s-1.9 1.1-3 1.1-2.2-.3-3-1.1c-.8-.8-1.1-1.7-1.1-2.8v-10.7c-.8 1.4-1.9 2.5-3.6 3.3-1.4.8-3.3 1.1-5 1.1-2.5 0-4.4-.6-6.3-1.7-1.9-1.1-3.3-2.8-4.4-5S0 98.5 0 95.8c0-2.8.6-5.2 1.7-7.4s2.5-3.9 4.4-5.2c1.9-1.1 3.9-1.9 6.3-1.9 1.9 0 3.6.3 5.2 1.1 1.4.8 2.8 1.9 3.6 3.3V85c0-1.1.3-2.2 1.1-2.8s1.7-1.1 3-1.1c.8.6 1.9.9 2.8 1.7zm-8.8 19c1.1-1.4 1.7-3.3 1.7-5.8s-.6-4.4-1.7-5.8-2.8-2.2-4.7-2.2-3.6.8-4.7 2.2-1.7 3.3-1.7 5.8.6 4.4 1.7 5.8c1.1 1.4 2.5 1.9 4.7 1.9 1.9.1 3.6-.5 4.7-1.9zM61.1 82.8c.8.8 1.1 1.7 1.1 3v20.6c0 1.1-.3 2.2-1.1 2.8-.8.8-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1-1.1-1.7-1.1-2.8v-.4c-.8 1.4-1.9 2.5-3.3 3.3-1.4.8-3 1.1-4.7 1.1-3.6 0-6.1-.8-7.7-2.8-1.7-1.9-2.5-5-2.5-8.8V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v13.2c0 1.7.3 2.8 1.1 3.6.8.8 1.7 1.1 3 1.1 1.7 0 3-.6 4.1-1.7 1.1-1.1 1.7-2.5 1.7-4.4V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.7-1.1 3-1.1 1-.1 2.1.2 2.9 1zM90 84.5c1.9 1.9 3 5 3 9.1v12.7c0 1.1-.3 2.2-1.1 2.8-.8.6-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1c-.6-.8-1.1-1.7-1.1-2.8v-.3c-.6 1.4-1.4 2.5-2.8 3.3s-2.8 1.1-4.7 1.1-3.6-.3-5-1.1-2.8-1.9-3.6-3-1.4-2.8-1.4-4.4c0-1.9.6-3.6 1.7-4.7s2.8-1.9 5-2.5 5.5-.8 9.4-.8H85v-1.1c0-1.7-.3-2.8-1.1-3.3-.8-.8-1.9-1.1-3.6-1.1-1.7 0-3.9.6-6.9 1.7-.8.3-1.7.6-2.2.6-.8 0-1.4-.3-1.9-.8s-.8-1.4-.8-2.2c0-.8.3-1.4.6-1.9s.8-.8 1.7-1.4c1.4-.8 3-1.4 4.7-1.7 1.9-.3 3.9-.6 5.5-.6 4-.4 7.1.5 9 2.4zm-6.6 18.4c1.1-1.1 1.4-2.5 1.4-4.4v-.8H84c-3 0-5.2.3-6.3.8-1.1.6-1.9 1.4-1.9 2.8 0 1.1.3 1.9 1.1 2.5.8.6 1.7 1.1 2.5 1.1 1.5-.3 2.9-.9 4-2zM123.9 84.5c1.7 1.9 2.5 5 2.5 8.8v12.9c0 1.1-.3 2.2-1.1 3-.8.6-1.9.8-3.3.8s-2.2-.3-3-1.1c-.8-.8-1.1-1.7-1.1-3V93.6c0-1.9-.3-3.3-1.1-4.1-.8-.8-1.7-1.4-3.3-1.4-1.7 0-3 .6-4.1 1.7-1.1 1.1-1.7 2.8-1.7 4.4V106c0 1.1-.3 2.2-1.1 3s-1.7 1.1-3 1.1c-1.4 0-2.5-.3-3-1.1-.8-.8-1.1-1.7-1.1-3V85.3c0-1.1.3-2.2 1.1-2.8.8-.6 1.9-1.1 3-1.1s2.2.3 2.8 1.1c.8.8 1.1 1.7 1.1 2.8v.8c1.1-1.4 2.2-2.8 3.9-3.3 1.7-.8 3.3-1.1 5.2-1.1 3.1 0 5.6.9 7.3 2.8zM150.3 104.9c.6.6.8 1.1.8 2.2s-.6 1.9-1.4 2.5-1.9.6-3.6.6h-1.7c-6.6-.6-9.9-3.9-9.9-10.2V89h-2.2c-1.1 0-2.2-.3-2.8-.8s-.8-1.4-.8-2.2c0-1.1.3-1.9.8-2.5.6-.6 1.7-.8 2.8-.8h2.2v-4.4c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v4.4h3.9c2.5 0 3.9 1.1 3.9 3.3 0 1.1-.3 1.7-.8 2.2s-1.7.8-2.8.8H143v11.8c0 1.1.3 1.9.8 2.5s1.4.8 2.2 1.1h1.7c1.2-.4 2-.1 2.6.5zM179.4 82.8c.8.8 1.1 1.7 1.1 3v20.6c0 1.1-.3 2.2-1.1 2.8-.8.8-1.9 1.1-3 1.1s-2.2-.3-2.8-1.1c-.6-.8-1.1-1.7-1.1-2.8v-.4c-.8 1.4-1.9 2.5-3.3 3.3s-3 1.1-4.7 1.1c-3.6 0-6.1-.8-7.7-2.8-1.7-1.9-2.5-5-2.5-8.8V85.9c0-1.1.3-2.2 1.1-3 .8-.8 1.9-1.1 3-1.1s2.2.3 3 1.1c.8.8 1.1 1.7 1.1 3v13.2c0 1.7.3 2.8 1.1 3.6.8.8 1.7 1.1 3 1.1 1.7 0 3-.6 4.1-1.7 1.1-1.1 1.7-2.5 1.7-4.4V85.9c0-1.1.3-2.2 1.1-3s1.7-1.1 3-1.1c1.3-.1 2.1.2 2.9 1zM227.9 84.5c1.7 1.9 2.5 4.7 2.5 8.8v12.9c0 1.4-.3 2.2-1.1 3-.8.6-1.9 1.1-3 1.1s-2.2-.3-3-1.1c-.8-.6-1.1-1.7-1.1-3V93.3c0-1.9-.3-3-.8-3.9-.6-.8-1.7-1.1-2.8-1.1-1.7 0-2.8.6-3.9 1.7s-1.4 2.5-1.4 4.4v11.8c0 1.4-.3 2.2-1.1 3-1.1.6-2.2.8-3.3.8s-2.2-.3-3-1.1c-.8-.6-1.1-1.7-1.1-3V93c0-1.9-.3-3-.8-3.9-.6-.8-1.7-1.1-2.8-1.1-1.7 0-2.8.6-3.9 1.7-.8 1.1-1.4 2.5-1.4 4.4V106c0 1.4-.3 2.2-1.1 3-.8.8-2.2 1.1-3.6 1.1-1.1 0-2.2-.3-3-1.1-.8-.6-1.1-1.7-1.1-3V85.3c0-1.1.6-2.2 1.4-2.8.8-.6 1.9-1.1 3-1.1s1.9.3 2.8 1.1 1.1 1.7 1.1 2.8v.6c.8-1.4 1.9-2.5 3.6-3.3 1.4-.8 3-1.1 5-1.1 1.9 0 3.6.3 5 1.1s2.5 2.2 3 3.9c.8-1.7 2.2-2.8 3.6-3.9 1.7-.8 3.3-1.4 5.5-1.4 2.9.5 5.1 1.4 6.8 3.3z"
    }
  }), _c('g', [_c('path', {
    staticClass: "logo-graphic",
    staticStyle: {
      "fill": "#4a89e5"
    },
    attrs: {
      "d": "M89.7 0C69.6 0 53.4 16.2 53.4 36.1s16.2 36.1 36.3 36.1 36.1-16.2 36.1-36.1S109.5 0 89.7 0zm0 61.4c-14 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3S115 22 115 36.1s-11.5 25.3-25.3 25.3z"
    }
  }), _c('path', {
    staticClass: "logo-graphic",
    staticStyle: {
      "fill": "#4a89e5"
    },
    attrs: {
      "d": "M122.2 70.7c-2.2 1.9-5.8 1.7-7.7-.6l-6.1-6.9c-1.9-2.2-1.7-5.8.6-7.7 2.2-1.9 5.8-1.7 7.7.6l6.1 6.9c1.9 2.5 1.6 5.8-.6 7.7z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "print",
      "aria-labelledby": "print",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("print results")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M101.1 35.2h-2.3V0H21.2v35.2h-2.3c-10 0-18 8.1-18 18v34.9c0 10 8.1 18 18 18h2.3V120h77.6v-13.8h2.3c10 0 18-8.1 18-18v-35c0-9.9-8.1-18-18-18zm-72.7-28h63.2v27.1H28.4V7.2zm-9.5 35.2H101c6 0 10.8 4.9 10.8 10.8V55H8.1v-1.8c0-5.9 4.9-10.8 10.8-10.8zm72.7 70.4H28.4v-37h63.2v37zm9.5-13.9h-2.3V68.6H21.2V99h-2.3c-6 0-10.8-4.9-10.8-10.8V62.3h103.8v25.9c0 5.9-4.9 10.7-10.8 10.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M84.5 83.6h-49c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6h49c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6zM63.8 97.1H35.5c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6h28.3c2 0 3.6-1.6 3.6-3.6 0-1.9-1.6-3.6-3.6-3.6z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "94.9",
      "cy": "48.8",
      "r": "3.9"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "email",
      "aria-labelledby": "email",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M111.2 39.2L73 1c-.6-.6-1.4-.9-2.2-1H22.3c-8 0-14.5 6.5-14.5 14.4v91.2c0 7.9 6.5 14.4 14.4 14.4h75.5c7.9 0 14.4-6.5 14.4-14.4v-64c.1-.9-.3-1.8-.9-2.4zm-10.7-1H79c-2.8 0-5.1-2.3-5.1-5.1V11.6l26.6 26.6zm-2.8 75H22.3c-4.2 0-7.6-3.4-7.6-7.6V14.4c0-4.2 3.4-7.6 7.6-7.6h44.8v26.3C67.1 39.6 72.4 45 79 45h26.4v60.6c0 4.2-3.5 7.6-7.7 7.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "dashboard",
      "aria-labelledby": "dashboard",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("back to mini calculators")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M55.6 55.4H0V.1h55.6v55.3zM4.2 51.2h47.3v-47H4.2v47zM120 55.4H64.4V.1H120v55.3zm-51.4-4.2h47.3v-47H68.6v47zM55.6 119.9H0V64.6h55.6v55.3zm-51.4-4.1h47.3v-47H4.2v47zM120 119.9H64.4V64.6H120v55.3zm-51.4-4.1h47.3v-47H68.6v47z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "retirement-calculator",
      "aria-labelledby": "retirement-calculator",
      "role": "img",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('title', [_vm._v("Retirement Calculator")]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M103.3 120c-3.6 0-7.1-1.7-9-4.9L40 26.6c-.4-.6-3.7-5.5-8.6-2.5-5 3-2 8.2-1.7 8.8l4.9 8c3.1 5 1.3 11.7-4 14.9-5.3 3.2-12 1.8-15.1-3.2L8.4 40.8c-.1-.2-11.8-22.5 10.3-36.1 22.1-13.5 37.8 6.1 38 6.3l.1.2 56.5 92.1c1.5 2.4 1.9 5.3 1.1 8.2-.8 2.8-2.6 5.2-5.1 6.7-1.9 1.2-4 1.8-6 1.8zM34.5 18.8c4.3 0 7.6 3.2 9.1 5.5l54.3 88.5c1.8 3 6 3.8 9.2 1.8 1.6-1 2.7-2.5 3.2-4.2.5-1.7.2-3.4-.6-4.8l-56.4-92c-1.2-1.4-14.1-16.5-32.4-5.2C2.4 19.7 11.4 37.5 12 38.8l7.1 11.6c1.8 3 6 3.8 9.2 1.8 3.3-2 4.4-6.1 2.6-9.1l-4.9-8c-1.9-3.2-3.8-10.4 3.1-14.6 2-1.2 3.8-1.7 5.4-1.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "loss-of-pension",
      "aria-labelledby": "loss-of-pension",
      "role": "img",
      "viewBox": "0 0 56.2 56.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.5 29.6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M46 27.2c-.5-1.1-1.4-2-2.6-2.6 0-.1 0-.2-.1-.3C42 15.7 35.6 9.4 28 9.4c-2.6 0-5 .8-7.2 2.1-1.2-1.1-2.8-1.9-4.6-1.9-3.6 0-6.6 2.9-6.6 6.6 0 2.5 1.4 4.7 3.6 5.8-.2.7-.4 1.5-.5 2.2-2.5 1.2-3.6 4.2-2.5 7.4.7 2 2.2 3.7 4 4.3 2.8 6.5 8.1 10.8 13.7 10.8S38.8 42.5 41.6 36c1.9-.6 3.5-2.3 4.2-4.4.8-1.5.8-3.1.2-4.4zm-35.6-11c0-3.3 2.7-5.9 5.9-5.9 3.3 0 5.9 2.7 5.9 5.9s-2.7 5.9-5.9 5.9c-3.3.1-5.9-2.6-5.9-5.9zm3.8 6.2s-.1 0-.1-.1c0 .1 0 .1.1.1zm30.1 8.7c-.6 1.7-1.9 3.1-3.4 3.4l-.5.1-.1.4c-2.5 6.1-7.3 10-12.2 10-5 0-9.8-3.9-12.2-10l-.2-.4-.4-.1c-1.4-.4-2.6-1.7-3.2-3.3-.8-2.4 0-4.7 1.9-5.3l.5-.2.1-.5c.1-.8.3-1.6.5-2.4.4.1.9.1 1.3.1 3.6 0 6.6-2.9 6.6-6.6 0-1.2-.3-2.3-.9-3.3 1.9-1.1 3.9-1.8 6.1-1.8 6.8 0 12.5 5.7 13.6 13.5l.1.6c.1.4.2.7.6.9.9.3 1.6.9 2 1.8.2.8.2 1.9-.2 3.1zM21.5 12.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.6 29.6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.5-1-1-1zM26 24.8l-5.2.7c-.2 0-.4.3-.4.5s.2.4.4.4h.1l5.2-.7c.2 0 .4-.3.4-.5-.1-.3-.3-.5-.5-.4zM35.4 25.5l-5.2-.7c-.2 0-.5.1-.5.4 0 .2.1.5.4.5l5.2.7h.1c.2 0 .4-.2.4-.4 0-.3-.2-.5-.4-.5zM18.2 19.2c.1-.1.1-.1.1-.2s0-.2-.1-.2c-.1-.1-.1-.1-.2-.1h-2.6v-2.2h1.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2s0-.1-.1-.2c0 0-.1-.1-.2-.1h-1.3v-1.1c0-.4.1-.6.3-.8.2-.2.4-.3.7-.3.2 0 .5 0 .7.1.2.1.5.3.8.5.1.1.2.1.2.1.1 0 .1 0 .2-.1 0-.1.1-.1.1-.2s0-.2-.1-.3c-.2-.2-.5-.4-.8-.5-.3-.1-.6-.2-1-.2-.5 0-.9.1-1.2.4-.3.3-.4.7-.4 1.2V16H14c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2s0 .1.1.2c0 0 .1.1.2.1h.6v2.2H14c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2s0 .2.1.2c.1.1.1.1.2.1h3.8c.2-.1.3-.2.4-.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M28.1 0C12.6 0 0 12.6 0 28.1s12.6 28.1 28.1 28.1c15.5 0 28.1-12.6 28.1-28.1S43.6 0 28.1 0zM2 28.1C2 13.7 13.7 2 28.1 2c6.7 0 12.8 2.5 17.4 6.7L9.3 46.2C4.8 41.5 2 35.1 2 28.1zm26.1 26.1c-6.6 0-12.7-2.5-17.3-6.6L46.9 10c4.5 4.7 7.3 11 7.3 18 0 14.5-11.7 26.2-26.1 26.2z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "mesothelioma-psla-calculator",
      "aria-labelledby": "mesothelioma-psla-calculator",
      "role": "img",
      "viewBox": "0 0 55.3 56.2"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "20.9",
      "cy": "32",
      "r": "1.5"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M10 20.1c-5.5 0-10-4.5-10-10S4.5.1 10 .1s10 4.5 10 10-4.5 10-10 10zM10 1c-5 0-9 4.1-9 9s4.1 9 9 9c5 0 9-4.1 9-9s-4-9-9-9z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M50.8 23c0-.2-.1-.5-.1-.7C48.8 9.4 39.2 0 27.8 0 24 0 20.4 1.1 17.2 3.1c.5.5.9 1 1.2 1.6C21.3 3 24.4 2 27.8 2c10.4 0 19.3 8.7 21 20.8l.1.6h.1c.1.6.2 1.1.8 1.3 3.2 1.1 4.4 4.3 3.1 8.1-.9 2.7-3.1 4.8-5.4 5.4l-.5.1-.2.5C43 48.1 35.6 54.2 27.9 54.2c-7.7 0-15.2-6.1-18.9-15.5l-.2-.5-.5-.1c-2.3-.6-4.2-2.7-5.1-5.3-1.3-3.9 0-7.5 3.1-8.6l.4-.2.1-.6c.2-1.3.4-2.5.8-3.7-.7-.2-1.3-.4-1.9-.7-.3 1.1-.6 2.3-.8 3.5-3.8 1.7-5.4 6.2-3.7 10.9 1.1 3.1 3.3 5.5 6 6.4 4.1 9.9 12.2 16.3 20.6 16.3 8.4 0 16.4-6.3 20.6-16.2 2.8-.8 5.2-3.3 6.4-6.5 1.5-4.6 0-8.7-4-10.4z"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "34.6",
      "cy": "32",
      "r": "1.5"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M16.7 25.3c-.2 0-.5-.2-.5-.4 0-.3.2-.5.4-.6l8-1.1c.3 0 .5.2.6.4 0 .3-.2.5-.4.6l-8.1 1.1zM38.8 25.3c-.1 0-.1 0 0 0l-8-1.1c-.3 0-.5-.3-.4-.6 0-.3.3-.5.6-.4l8 1.1c.3 0 .5.3.4.6-.2.2-.4.4-.6.4zM9.4 15.5c-.2-.2-.3-.4-.3-.6 0-.3.1-.5.3-.7.2-.2.4-.3.6-.3.2 0 .5.1.6.3.2.2.2.4.2.7 0 .3-.1.5-.2.6-.2.2-.4.2-.6.2-.2 0-.5 0-.6-.2zm.3-2.8c-.1-.1-.1-.2-.1-.3l-.4-7.3c0-.2 0-.4.2-.6.2-.1.3-.2.6-.2.2 0 .4.1.6.2.1.1.2.3.2.6l-.4 7.2c0 .1-.1.3-.1.3-.1.1-.2.1-.3.1-.1.1-.2.1-.3 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "loss-of-earnings",
      "aria-labelledby": "loss-of-earnings",
      "viewBox": "0 0 56.2 56.2"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M22.9 34.9c-.4 0-.7-.3-.7-.7V18.6c0-3.2.7-5.6 2.1-7.2 1.2-1.4 2.9-2.1 5-2.1 4.1 0 8.7 3.1 8.7 6 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-1.9-3.8-4.6-7.3-4.6-1.1 0-2.7.3-4 1.7-1.2 1.4-1.8 3.5-1.8 6.3v15.6c.1.3-.2.6-.6.6z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M37.3 35.2l-18.5-.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7l18.4.3c.4 0 .7.3.7.7.1.4-.2.7-.6.7zM29.9 23.7l-11.1-.3c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7l11.1.3c.4 0 .7.3.7.7 0 .5-.3.7-.7.7z"
    }
  }), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 46.9c-6.1 0-12.5-1.3-12.5-3.7 0-2.4 6.5-3.7 12.5-3.7s12.5 1.3 12.5 3.7c0 2.4-6.4 3.7-12.5 3.7zm0-6.9c-7 0-11.9 1.6-11.9 3.1s4.9 3.1 11.9 3.1S40 44.6 40 43.1c0-1.4-4.9-3.1-11.9-3.1z"
    }
  })]), _c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 44.6c-2.6 0-7.4-.4-7.4-1.9s4.8-1.9 7.4-1.9c2.6 0 7.4.4 7.4 1.9s-4.9 1.9-7.4 1.9zm0-3.1c-4.4 0-6.7.9-6.7 1.2s2.3 1.2 6.7 1.2 6.7-.9 6.7-1.2-2.3-1.2-6.7-1.2z"
    }
  })]), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M28.1 0C12.6 0 0 12.6 0 28.1s12.6 28.1 28.1 28.1c15.5 0 28.1-12.6 28.1-28.1S43.6 0 28.1 0zM2 28.1C2 13.7 13.7 2 28.1 2c6.7 0 12.8 2.5 17.4 6.7L9.3 46.2C4.8 41.5 2 35.1 2 28.1zm26.1 26.1c-6.6 0-12.7-2.5-17.3-6.6L46.9 10c4.5 4.7 7.3 11 7.3 18 0 14.5-11.7 26.2-26.1 26.2z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56dac7d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/Icons.vue
// module id = 1699
// module chunks = 0